<template>
  <Modal
    v-model="_value"
    width="500"
    title="短信设置HIK货运平台（通道3）"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <p>确认发送短信：设置HIK货运平台（通道3）</p>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuphikgghyptsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {

        //共三条短信，1、设置IP或域名。2、设置卡号。3、设置通道使能及协议
        // console.log(this.simNum.substring(6))
        store.dispatch('PositioningDeviceInfoServ_SearchByName',{
          params:{name:this.simNum.substring(6)},
          urlparams:{},
        }).then(res => {
          if (store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0) {
            this.sendSMS('ZIP:2,jt1.gghypt.net,7008;A')

            setTimeout(() => {
                this.sendSMS('TEL_ID:2,' + 0 + store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].terminalNum + ',' + this.simNum.substring(6) + ';A')
              }
              , 4000)

            setTimeout(() => {
                this.sendSMS('JT808Ver:2,1;A')
              }
              ,70000)

            setTimeout(() => {
                this.sendSMS('PROTO:2,1,1,6;A')
              }
              , 10000)
          }else {
            this.$Message.error('请检查主机号（卡号）')
          }
        }).catch(err => {
          console.log(err)
        })

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
